var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDownloadFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 58.3",
    enableBackground: "new 0 0 50 58.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#3E3E3E",
    d: "M5.6,49.2L5.6,49.2h38.7c1.6,0,2.8,1.2,2.8,2.7v1.5 c0,1.6-1.2,2.9-2.8,2.9H5.6c-1.5,0-2.8-1.3-2.8-2.9v-1.5C2.8,50.4,4.1,49.2,5.6,49.2L5.6,49.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#70CAF2",
    d: "M41.2,27.8L25.4,43.7c-0.2,0.2-0.5,0.2-0.7,0l-16-15.9 c-0.2-0.2-0.2-0.5,0-0.7l2.1-2.1l12.6,12.6V3.4c0-0.9,0.7-1.7,1.7-1.7c1,0,1.8,0.8,1.8,1.7v34l12.2-12.3l2.1,2.1 C41.4,27.3,41.4,27.6,41.2,27.8L41.2,27.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadFolder);
export default __webpack_public_path__ + "static/media/ic_download_folder.5e8472bd8bff7f7c64033e5545e1d6f4.svg";
export { ForwardRef as ReactComponent };